module.exports = __webpack_public_path__ + "static/img/office-de-updated.5b52cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office-de-updated.jpg
// module id = 586
// module chunks = 1